import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants } from 'utils';

const Bills = () => {
	const user = useSelector((state: RootState) => state.user);

	if (user?.level_id == Constants.LEVELS.ADMIN || user?.level_id == Constants.LEVELS.MODERATOR) {
		return <Redirect to="/admin/bills/report" />
	}
	else if (user?.level_id == Constants.LEVELS.CLIENT || user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) {
		return <Redirect to="/client/bills/report" />
	}
}

export default Bills;